"use strict";
exports.__esModule = true;
exports.SvgColorableStarFilled = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgColorableStarFilled = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("path", { fill: "transparent", d: "M0 0h20v20H0z" }),
    react_1["default"].createElement("path", { fill: "currentColor", d: "M10.01 1.43c.41.02.71.23.89.6L13 6.49l4.73.72c.39.07.67.32.79.7.12.38.03.74-.24 1.02l-3.44 3.51.82 4.97c.12.75-.63 1.38-1.33 1.08l-.2-.09L10 16.12l-4.1 2.26c-.32.18-.54.24-.84.16-.48-.14-.8-.62-.72-1.12l.81-4.98L1.7 8.92c-.01-.02-.03-.03-.04-.05-.49-.61-.17-1.53.59-1.65l.51-.08L7 6.49l2.11-4.48.07-.12c.15-.25.38-.4.64-.45l.17-.01h.02z" }))); };
//# sourceMappingURL=ColorableStarFilled.js.map